import { render, staticRenderFns } from "./buffet.vue?vue&type=template&id=ed0e9afe&scoped=true&"
import script from "./buffet.vue?vue&type=script&lang=js&"
export * from "./buffet.vue?vue&type=script&lang=js&"
import style0 from "./buffet.vue?vue&type=style&index=0&id=ed0e9afe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0e9afe",
  null
  
)

export default component.exports